/** @jsx jsx */
import { jsx } from '@emotion/react';
import configSchema from '../../../@generated/current-config-schema.json';
import { getPropertyDescriptionInfo } from '../../utils/schema-extractor';
import { colors } from '../../theme';

const PropDescription = ({
  definitionName,
  propertyName,
  descType = 'ld'
}: {
  definitionName: string;
  propertyName: string;
  descType: 'ld' | 'sd';
}) => {
  const { definitions } = configSchema;
  const desc = getPropertyDescriptionInfo({
    definitions: definitions as unknown as { [defName: string]: ObjectSchemaNode },
    definitionName,
    propertyName
  });
  return (
    <div
      css={{
        color: colors.font,
        lineHeight: 1.75,
        fontSize: '15px',
        letterSpacing: '0.025em',
        // paddingLeft: '4px',
        paddingBottom: '6px'
      }}
    >
      <span dangerouslySetInnerHTML={{ __html: `${desc[descType] || 'No description'}` }} />
    </div>
  );
};

export default PropDescription;
